const cant = [
  'объяснять;',
  'давать обратную связь;',
  'задавать вопросы;',
  'видеть причины ошибок;',
  'развивать других;',
  'терпеливо сопровождать обучение;',
  'передавать ответственность.',
];

export default function SpecialistVsMentor() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Почему сильный специалист не всегда становится хорошим наставником
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Человек может отлично выполнять свою работу, но при этом не уметь:
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 max-w-4xl mx-auto mb-12">
          {cant.map((c, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-gray-50 rounded-lg border border-gray-200 p-4 hover:border-teal-300 transition-colors">
              <i className="ri-close-circle-line text-red-400 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700 leading-relaxed">{c}</span>
            </div>
          ))}
        </div>

        <div className="bg-gray-900 rounded-2xl p-6 md:p-10 text-center">
          <p className="text-base md:text-xl text-white leading-relaxed font-semibold">
            Назначение лучшего специалиста наставником само по себе ещё не создаёт систему наставничества. Наставников также необходимо развивать.
          </p>
        </div>
      </div>
    </section>
  );
}